export default {
  index(url) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements' + url);
  },
  indexEmploymentContractAgreements() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/employment_contracts?list');
  },
  show(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/' + id);
  },
  store(data) {
    let agreement = JSON.parse(JSON.stringify(data.agreement));
    agreement.crm = agreement.crm.id;
    agreement.number = agreement.number.number;
    agreement.type = agreement.type.id;
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/agreements', {
      agreement,
      pricelist: data.pricelist,
      _actions: data.actions,
    });
  },
  update(data) {
    let agreement = JSON.parse(JSON.stringify(data.agreement));
    agreement.crm = agreement.crm.id;
    agreement.type = agreement.type.id;
    agreement.number = agreement.number.number;

    delete agreement.boss;

    return axios.put(import.meta.env.VITE_SITE_URL + '/crms/agreements/' + agreement.id, {
      agreement,
      pricelist: data.pricelist,
      _actions: data.actions,
    });
  },
  destroy(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/crms/agreements/' + id);
  },
  print(payload) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print', { data: payload });
  },
  preview(payload) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print/preview', { data: payload });
  },
  setTerminationDate(agreement) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/crms/agreements/set-termination-date/' + agreement.id, { agreement });
  },
  getTaxDeductibleAmount(payload) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/agreements/tax-deductible-amount', payload);
  },
  getVersions(original) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/versions/' + original);
  },
  isProfileValidToAddAgreement(data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/agreements/is-profile-valid', data);
  },
  confirmAgreement(data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/agreements/confirm-agreement', data);
  },
  sendInvitationEmail({ agreementId }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/agreements/send-invitational-email/${ agreementId }`);
  },
  sendNotificationEmail({ agreementId }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/agreements/send-notification-email/${ agreementId }`);
  },
  sendToSign(id, data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/agreements/' + id + '/send-to-sign', data);
  },
  storeFile(id, data) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/agreements/' + id + '/files', data);
  },
  DEDUCTIONS: {
    index(url) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/payments/deductions' + url);
    },
    indexByPeriod(payload) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/payments/deductions/byPeriod', payload);
    },
    indexAgreementDeductionsForPayment(payment) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/payments/deductions/payment/' + payment);
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/payments/deductions/' + id);
    },
    store(deduction) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/payments/deductions', { paymentdeduction: prepareDeduction(deduction) });
    },
    update(deduction) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/crms/payments/deductions/' + deduction.id, { paymentdeduction: prepareDeduction(deduction) });
    },
  },
  NUMBER: {
    generate(payload) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/number', payload);
    },
  },
  TYPES: {
    index() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/types');
    },
    indexAgreementTypes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreement-types');
    },
  },
  CODES: {
    indexInsuranceTitleCodeOptions() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/insurance-title-codes');
    },
    indexRetirementEntitlementCodes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/retirement-entitlement-codes');
    },
    indexDisabilityLevelCodes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/disability-level-codes');
    },
    indexHealthInsuranceCodes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/agreements/health-insurance-codes');
    },
  },
};

function prepareDeduction(deduction) {
  deduction = { ...deduction };
  if (deduction.single) {
    let id = deduction.agreements.id;
    deduction.agreements = [];
    deduction.agreements[0] = { id };
  } else {
    deduction.agreements = deduction.agreements.map(el => {
      return {
        id: el.id,
      };
    });
  }
  return deduction;
}
